import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '关于我们', href: '#about' },
  { label: '吃瓜视频', href: '#media' },
  { label: '最新动态', href: '#updates' },
  { label: '投稿联系', href: '#contact' },
];

export default function Home() {
  return (
    <>
      <Header navItems={navItems} />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <RankingSection />
        <AboutSection />
        <IndexSection />
        <FAQSection />
        <CommentsSection />
        <ContactSection />
        <UpdatesSection />
        <CardsSection />
        <CarouselSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}